import React from 'react';
import { motion } from 'framer-motion';
import { Shield, ShieldAlert, ShieldCheck, ShieldX } from 'lucide-react';
import { cn } from '../../lib/utils';

export const SafetyBadge = ({ risk = 'low', mode = 'full', className }) => {
  const getBadgeConfig = () => {
    if (mode === 'diagnosis-only') {
      return {
        icon: ShieldAlert,
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        borderColor: 'border-warning/30',
        label: 'DIAGNOSIS ONLY',
        glow: 'shadow-glow-warning',
      };
    }

    switch (risk) {
      case 'high':
        return {
          icon: ShieldX,
          color: 'text-destructive',
          bgColor: 'bg-destructive/10',
          borderColor: 'border-destructive/30',
          label: 'HIGH RISK',
          glow: '',
        };
      case 'medium':
        return {
          icon: ShieldAlert,
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/30',
          label: 'MODERATE RISK',
          glow: '',
        };
      default:
        return {
          icon: ShieldCheck,
          color: 'text-success',
          bgColor: 'bg-success/10',
          borderColor: 'border-success/30',
          label: 'LOW RISK',
          glow: '',
        };
    }
  };

  const { icon: Icon, color, bgColor, borderColor, label, glow } = getBadgeConfig();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1.5 border',
        bgColor,
        borderColor,
        glow,
        className
      )}
      data-testid="safety-badge"
    >
      <Icon className={cn('w-4 h-4', color)} />
      <span className={cn('font-mono text-xs font-bold uppercase', color)}>
        {label}
      </span>
    </motion.div>
  );
};

export default SafetyBadge;
